import { render, staticRenderFns } from "./ProjList.vue?vue&type=template&id=accfd83c"
import script from "./ProjList.vue?vue&type=script&lang=js"
export * from "./ProjList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports